'use client';
import { createFetch, IOptions, logError } from '../../useApi/api';
import { MessagePlugin } from 'tdesign-react';

interface IClientOptions extends IOptions {
  isOnlyValidateReq?: boolean;
  cache?: RequestCache;
  errorMessage?: boolean; // 开启提示
}

const SSVIntlFetch = async <T>(
  url: string,
  { errorMessage = true, ...options }: IClientOptions
) => {
  try {
    const res = (await createFetch(url, options)) as Response;
    // 401/403 统一处理跳转登录页（不受 isOnlyValidateReq 影响）
    if (!res.ok && [401, 403].includes(res.status) && !options.skipIntercept) {
      if (window.location.pathname === '/case/activity/summit') {
        return { code: res.status } as T;
      }
      const hostname = window.location.hostname;
      const isEnVersion =
        hostname.startsWith('en.') || hostname.startsWith('en-');
      // 英文版添加语言参数，确保登录页正确显示英文
      const langParam = isEnVersion ? '&s_language=en' : '';
      window.location.href = `/login?s_url=${encodeURIComponent(
        window.location.href
      )}${langParam}`;
      return;
    }
    if (!res.ok && [401, 403].includes(res.status) && options.skipIntercept) {
      return { code: res.status } as T;
    }

    if (!res.ok && !options?.isOnlyValidateReq) {
      // 其他错误状态码处理（如有需要）
    }
    if (res.type == 'cors') return res as T;

    // 获取content-disposition响应头
    const contentDisposition = res.headers.get('content-disposition') ?? '';
    if (contentDisposition.includes('attachment')) return { data: res } as T;

    const data = res ? await res?.json() : res;
    // 错误提示
    if (data.code !== 0 && errorMessage) {
      MessagePlugin.error({ zIndex: 1000000, content: data.msg });
      return Promise.reject(data.msg);
    }
    return data as T;
  } catch (error: any) {
    logError('error', url, options.method || 'GET', error);
    console.log('error');
    throw error;
  }
};

export const SSVIntlApi = {
  async get<T>(url: string, options: IClientOptions = {}) {
    return await SSVIntlFetch<T>(url, options);
  },
  async post(url: string, data: any = {}, options: IClientOptions = {}) {
    const res = await SSVIntlFetch<{ data: any }>(url, {
      data,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      ...options,
    });
    return res?.data;
  },
  async delete(url: string) {
    return await SSVIntlFetch(url, { method: 'DELETE' });
  },
  async put<T>(url: string, data: any = {}, options: IClientOptions = {}) {
    const res = await SSVIntlFetch(url, {
      data,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      ...options,
    });
    return res as T;
  },
};
